/* Time picker helpers — 2 selects: Hour+AM/PM combined, then Minute (00/15/30/45).
   Times are stored internally as 24h "HH:MM". */
export const HOUR_OPTIONS = Array.from({ length: 24 }, (_, h) => {
  const period = h >= 12 ? 'PM' : 'AM';
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return { value: h, label: `${h12} ${period}` };
});

export const MINUTE_OPTIONS = ['00', '15', '30', '45'];

/* "All day" events have no backend flag — they're stored as 09:00–23:59 on the
   date. 23:59 isn't reachable from the pickers, so that pair marks one. */
export const ALL_DAY_START = '09:00';
export const ALL_DAY_END = '23:59';

export function isAllDay(startTime, endTime) {
  return startTime === ALL_DAY_START && endTime === ALL_DAY_END;
}

export function splitTime(t) {
  const [h, m] = t.split(':');
  return { h: parseInt(h, 10), m };
}

export function joinTime(h24, m) {
  return String(parseInt(h24, 10)).padStart(2, '0') + ':' + m;
}
